import { useEffect } from 'react';
import EventSearch from "../components/events/EventSearch";
import Footer from '../components/footers/Footer';
import ApplicationBar from "../components/shared/ApplicationBar";
import logo from '../logo.png';

const Events = () => {
    useEffect(() => {
        document.title = 'FestiShare Support - Events';
    }, []);

    return (
        <div>
            <div className="w-full flex justify-center">
                <img className="flex justify-center shadow rounded-xl" src={logo} alt="Logo" width={63} />
            </div>
            <EventSearch />
            <Footer />
            <ApplicationBar />
        </div>
    );
};

export default Events;
